import React, { useState } from "react";
import useTheme from "../../../../common/hooks/useTheme";
import { colorCodingFeedbackMessage } from "../../store/helper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

type Props = {
  data: {
    text: string;
    type: number;
  };
  colorCodingType: number;
};

const ScoreMessageInfoPanel = ({ data, colorCodingType }: Props) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  let containerStyle = {
    borderColor: "",
    backgroundColor: "",
  };

  // Function to get styles based on feedback type
  switch (colorCodingFeedbackMessage[colorCodingType]) {
    case "Excellent":
      containerStyle = {
        borderColor: theme.colorTokens.S[30],
        backgroundColor: theme.colorTokens.S[20],
      };
      break;
    case "Good":
      containerStyle = {
        borderColor: theme.colorTokens.S[20],
        backgroundColor: theme.colorTokens.S[10],
      };
      break;
    case "Warning":
      containerStyle = {
        borderColor: theme.colorTokens.W[20],
        backgroundColor: theme.colorTokens.W[10],
      };
      break;
    case "Bad":
      containerStyle = {
        borderColor: theme.colorTokens.D[20],
        backgroundColor: theme.colorTokens.D[10],
      };
      break;
    default:
      containerStyle = {
        borderColor: theme.colorTokens.N[40],
        backgroundColor: theme.colorTokens.N[30],
      };
  }

  return (
    <div style={styles.wrapper(theme, isExpanded)}>
      <div
        style={styles.iconWrapper(theme, isExpanded)}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <KeyboardArrowDownIcon
          sx={{
            fontSize: 32,
            borderRadius: "50%",
            color: theme.colors_ds.PRIMARY_ICON_MAIN,
          }}
        />
      </div>
      {isExpanded && (
        <div style={styles.container(theme, containerStyle)}>{data.text}</div>
      )}
    </div>
  );
};

export default ScoreMessageInfoPanel;

const styles = {
  container: (
    theme: any,
    containerStyle: { borderColor: string; backgroundColor: string }
  ) => ({
    margin: "24px 16px",
    backgroundColor: containerStyle.backgroundColor,
    border: `1px solid ${containerStyle.borderColor}`,
    borderRadius: "8px",
    padding: "8px 16px",
    fontFamily: "var(--fonts-regular)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
  }),
  wrapper: (theme: any, open: boolean) => ({
    margin: "32px -12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTop: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    borderBottom: `1px solid ${
      open ? theme.colors_ds.NEUTRAL_BORDER_WEAK : "transparent"
    }`,
    position: "relative" as "relative",
  }),
  iconWrapper: (theme: any, open: boolean) => ({
    width: "28px",
    height: "28px",
    paddingTop: "2px",
    borderRadius: "50%",
    backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    boxShadow: "var(--box-shadow-general)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute" as "absolute",
    top: 0,
    left: "16px",
    transform: `translateY(-50%) rotate(${open ? "-180deg" : "0deg"})`,
    transition: "transform 0.3s ease",
    cursor: "pointer",
  }),
};
